import { render, staticRenderFns } from "./Connected.vue?vue&type=template&id=884bc1f0&scoped=true&"
import script from "./Connected.vue?vue&type=script&lang=js&"
export * from "./Connected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884bc1f0",
  null
  
)

export default component.exports